import React from "react";
import { RouteComponentProps } from "react-router";
import { V2 } from "../../Api";

import withTitle from "../withTitle";

interface IMetricsAssessmentTypesViewState {
    isLoading: boolean | string;

    assessmentTypes: any[];
}

class MetricsAssessmentTypesView extends React.Component<RouteComponentProps<any>, IMetricsAssessmentTypesViewState> {
    constructor(props: Readonly<RouteComponentProps<any>>) {
        super(props);

        const state: IMetricsAssessmentTypesViewState = {
            isLoading: true,

            assessmentTypes: []
        };

        this.state = state;
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        return (
            <div className="viewer-root">
                <table className="table-vertical">
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th className="col-smallest"># Questions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.assessmentTypes.map(a => <tr key={a.id} className="clickable" onClick={() => this.editAssessmentType(a.id)}>
                            <td>{a.name}</td>
                            <td className="col-right-vt inline" data-caption="Questions: ">{a.questionsCount}</td>
                        </tr>)}
                    </tbody>
                </table>
            </div>
        );
    }

    private async loadData() {
        try {
            const assessmentTypes = await V2.get<any[]>("metrics/assessments/types");

            this.setState({
                isLoading: false,
                assessmentTypes
            });
        }
        catch (e) {
            this.setState({
                isLoading: e.message || "Could not load assessment types"
            });
        }
    }

    private editAssessmentType(id: string) {
        this.props.history.push(`/metrics/assessment/types/${id}`);
    }
}

export default withTitle("Employee Assessment Types", MetricsAssessmentTypesView);
